import React from "react";
import PrimaryGreenButton from "../../components/button/PrimaryGreenButton";
import errorCircle from "../../assets/images/icon/error-circle.svg";
import SuccessStyle from "../../assets/images/success-style.png";

export default function RedeemGiftMemberErrorCat({ onClick }) {
  return (
    <div
      className="min-h-screen relative overflow-hidden flex flex-col"
      style={{
        background:
          "linear-gradient(129.17deg, #213468 22.83%, #213468 36.49%, #1D4164 41.4%, #15645A 50.69%, #079D4A 63.25%, #07A14A 63.8%, #07A14A 77.45%)",
      }}
    >
      <img
        src={SuccessStyle}
        alt="logo"
        className="w-3/4 absolute top-0 right-0 mt-[-20px] mr-[-20px]"
      />

      <div
        className="flex flex-col justify-between items-center px-5 pt-16 pb-10 mx-auto"
        style={{ height: "90vh" }}
      >
        <div className="flex flex-col items-center text-center">
          <img src={errorCircle} alt="error icon" className="w-16 h-16 mb-4" />
          <div className="text-4xl text-white leading-tight mb-2">ขออภัย</div>
          <div className="text-xl text-white leading-tight">
            Coin ของคุณไม่เพียงพอ
          </div>
        </div>

        <div className="flex-grow"></div>

        <div className="w-full mt-auto">
          <PrimaryGreenButton
            variant="contained"
            className="w-full !bg-[#082e683d] rounded-full py-3"
            sx={{
              border: "1px solid #FFFFFF",
            }}
            onClick={onClick}
          >
            กลับไปหน้าแลกของรางวัล
          </PrimaryGreenButton>
        </div>
      </div>
    </div>
  );
}
